export default {
  globalParams: {},
  xtdConfig: {}
}
